export function createMatrix(elements) {
  return {
    elements,
    rows() {
      return elements.length;
    },
    e(row, col) {
      return elements[row - 1][col - 1];
    },
    multiply(other) {
      const a = elements;
      const b = other.elements;
      const result = [];

      for (let i = 0; i < a.length; i++) {
        result[i] = [];
        for (let j = 0; j < b[0].length; j++) {
          let sum = 0;
          for (let k = 0; k < a[0].length; k++) {
            sum += a[i][k] * b[k][j];
          }
          result[i][j] = sum;
        }
      }

      return createMatrix(result);
    },
  };
}

export function columnVector(values) {
  return createMatrix(values.map((value) => [value]));
}

export function extractColumn(matrix, colIndex = 1) {
  const result = [];
  for (let i = 0; i < matrix.rows(); i++) {
    result[i] = matrix.e(i + 1, colIndex);
  }
  return result;
}
